import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-qlaivsim',
  templateUrl: './qlaivsim.component.html',
  styleUrls: ['./qlaivsim.component.scss']
})
export class QlaivsimComponent implements OnInit {

  exposition: CardContent = {
    title: 'Q-LAIV-Sim',
    subtitle: 'Evaluating the cost-effectiveness of quadrivalent influenza vaccines',
    image_source: 'assets/images/Q-LAIV-Sim.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients / Partners</h4>AstraZeneca, Epimos',
      '<h4>Methods</h4>Deterministic Compartmental Modelling',
      '<h4>Technology / Skills</h4>Java, Swing, RK4',
      '<h4>Term</h4>2011 - 2015',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
